module.exports = __webpack_public_path__ + "img/خلاق.0f787d14.jpg";